// Shared state for the Wasapi template CRUD grafted onto Chatwoot's official
// Settings -> Templates page. The official page only lists, syncs and previews templates; the
// pieces below add create/edit/duplicate/delete against the Meta Graph API.
//
// A module-level singleton keeps the two mount points (the header host and the per-card actions)
// in sync without threading provide/inject through the upstream components we do not own.
import { reactive } from 'vue';
import { EDITABLE_STATUSES } from './helpers';

export const CLOUD_PROVIDER = 'whatsapp_cloud';

const state = reactive({
  // Set by the host component; the card actions call it to reopen the dialog.
  openDialog: null,
  requestDelete: null,
  refresh: null,
});

// Templates we can write to: official Cloud API inboxes only (on-premise and 360dialog cannot).
export const isManageable = template =>
  (template?.inboxes || []).some(
    inbox =>
      inbox.channel_type === 'Channel::Whatsapp' &&
      inbox.provider === CLOUD_PROVIDER
  );

export const isEditable = template =>
  isManageable(template) && EDITABLE_STATUSES.includes(template?.status);

export const inboxIdFor = template =>
  (template?.inboxes || []).find(
    inbox =>
      inbox.channel_type === 'Channel::Whatsapp' &&
      inbox.provider === CLOUD_PROVIDER
  )?.id || null;

export const registerHost = handlers => Object.assign(state, handlers);

export const openTemplate = (template, inboxId) =>
  state.openDialog?.(template, inboxId);

export const duplicateTemplate = template =>
  state.openDialog?.(
    { ...template, id: null, name: '', status: null },
    inboxIdFor(template)
  );

export const deleteTemplate = template =>
  state.requestDelete?.(template, inboxIdFor(template));
